import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_MARIGRAM_REQUEST,
  GET_EDIT_MARIGRAM_SUCCESS,
  GET_EDIT_MARIGRAM_FAILURE,
  UPDATE_EDIT_MARIGRAM_REQUEST,
  UPDATE_EDIT_MARIGRAM_SUCCESS,
  UPDATE_EDIT_MARIGRAM_FAILURE,
  CREATE_EDIT_MARIGRAM_REQUEST,
  CREATE_EDIT_MARIGRAM_SUCCESS,
  CREATE_EDIT_MARIGRAM_FAILURE,
  EDIT_MARIGRAM_TSUNAMI_REQUEST,
  EDIT_MARIGRAM_TSUNAMI_SUCCESS,
  EDIT_MARIGRAM_TSUNAMI_FAILURE,
  EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST,
  EDIT_MARIGRAM_TSUNAMI_SEARCH_SUCCESS,
  EDIT_MARIGRAM_TSUNAMI_SEARCH_FAILURE,
  EDIT_MARIGRAM_REFERENCE_REQUEST,
  EDIT_MARIGRAM_REFERENCE_SUCCESS,
  EDIT_MARIGRAM_REFERENCE_FAILURE,
  EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST,
  EDIT_MARIGRAM_REFERENCE_SEARCH_SUCCESS,
  EDIT_MARIGRAM_REFERENCE_SEARCH_FAILURE,
  EDIT_MARIGRAM_COUNTRY_REQUEST,
  EDIT_MARIGRAM_COUNTRY_FAILURE,
  EDIT_MARIGRAM_COUNTRY_SUCCESS,
  EDIT_MARIGRAM_LOCATION_REQUEST,
  EDIT_MARIGRAM_LOCATION_FAILURE,
  EDIT_MARIGRAM_LOCATION_SUCCESS,
  EDIT_MARIGRAM_STATE_REQUEST,
  EDIT_MARIGRAM_STATE_FAILURE,
  EDIT_MARIGRAM_STATE_SUCCESS,
} from './marigramEditReducer';


const getMarigramSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/marigrams/${action.id}`, ...action }),
  requestType: GET_EDIT_MARIGRAM_REQUEST,
  successType: GET_EDIT_MARIGRAM_SUCCESS,
  failureType: GET_EDIT_MARIGRAM_FAILURE,
});

const createMarigramSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/marigrams', ...action }),
  requestType: CREATE_EDIT_MARIGRAM_REQUEST,
  successType: CREATE_EDIT_MARIGRAM_SUCCESS,
  failureType: CREATE_EDIT_MARIGRAM_FAILURE,
  successMessage: 'Saved',
});

const updateMarigramSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/marigrams/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_MARIGRAM_REQUEST,
  successType: UPDATE_EDIT_MARIGRAM_SUCCESS,
  failureType: UPDATE_EDIT_MARIGRAM_FAILURE,
  successMessage: 'Saved',
});

const getTsunamiSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/${action.id}`, ...action }),
  requestType: EDIT_MARIGRAM_TSUNAMI_REQUEST,
  successType: EDIT_MARIGRAM_TSUNAMI_SUCCESS,
  failureType: EDIT_MARIGRAM_TSUNAMI_FAILURE,
});

const searchTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/events', ...action }),
  requestType: EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST,
  successType: EDIT_MARIGRAM_TSUNAMI_SEARCH_SUCCESS,
  failureType: EDIT_MARIGRAM_TSUNAMI_SEARCH_FAILURE,
});


const getReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/${action.id}/references`, ...action }),
  requestType: EDIT_MARIGRAM_REFERENCE_REQUEST,
  successType: EDIT_MARIGRAM_REFERENCE_SUCCESS,
  failureType: EDIT_MARIGRAM_REFERENCE_FAILURE,
});

const searchReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST,
  successType: EDIT_MARIGRAM_REFERENCE_SEARCH_SUCCESS,
  failureType: EDIT_MARIGRAM_REFERENCE_SEARCH_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/countries', ...action }),
  requestType: EDIT_MARIGRAM_COUNTRY_REQUEST,
  successType: EDIT_MARIGRAM_COUNTRY_SUCCESS,
  failureType: EDIT_MARIGRAM_COUNTRY_FAILURE,
});


const getLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/locations', ...action }),
  requestType: EDIT_MARIGRAM_LOCATION_REQUEST,
  successType: EDIT_MARIGRAM_LOCATION_SUCCESS,
  failureType: EDIT_MARIGRAM_LOCATION_FAILURE,
});

const getStatesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/states', ...action }),
  requestType: EDIT_MARIGRAM_STATE_REQUEST,
  successType: EDIT_MARIGRAM_STATE_SUCCESS,
  failureType: EDIT_MARIGRAM_STATE_FAILURE,
});


export const marigramEditSagas = [
  getMarigramSaga,
  createMarigramSaga,
  updateMarigramSaga,
  getTsunamiSaga,
  searchTsunamisSaga,
  getReferencesSaga,
  searchReferencesSaga,
  getCountriesSaga,
  getLocationsSaga,
  getStatesSaga,
];
